import { format } from 'date-fns';

export function makeCsvFilename(prefix: string): string {
  return `${prefix}-${format(new Date(), 'yyyy-MM-dd')}.csv`;
}

export function downloadCsv(
  headers: string[],
  rows: string[][],
  filename: string
): void {
  const escape = (val: string) =>
    val.includes(',') || val.includes('"') || val.includes('\n')
      ? `"${val.replace(/"/g, '""')}"`
      : val;
  const csv = [headers, ...rows]
    .map((row) => row.map(escape).join(','))
    .join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
